import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingDummyRoomDefaultUpdateMutation = graphql(/* GraphQL */ `
	mutation ExistingDummyRoomDefaultUpdate($input: RoomDummyInput!) {
		roomDummyUpdate(input: $input) {
			userErrors
			roomDummy {
				id
				hotelID
				roomID
				inSale
				maxRoomNum
				capacityPeopleMaximum
				capacityAdultMaximum
				capacityKidsMaximum
				isKidsUnavailable
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				name
				catchCopy
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
